module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('d-modal', {
    attrs: {
      "show-close": false
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "d-modal",
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header",
    style: ({
      'background': _vm.firstInSubjectsWithSameName.color
    })
  }, [_c('h2', {
    staticStyle: {
      "color": "#ffffff"
    }
  }, [_vm._v("\""), _c('b', [_vm._v(_vm._s(_vm.firstInSubjectsWithSameName.name))]), _vm._v("\" " + _vm._s(_vm.i18n[_vm.locale]['exists']))]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__close icon__bg-circle",
    staticStyle: {
      "color": "#ffffff"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content"
  }, [_c('p', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['the_subject']) + ": \""), _c('b', [_vm._v(_vm._s(_vm.firstInSubjectsWithSameName.name))]), _vm._v("\" "), _c('span', [_vm._v(_vm._s(_vm.i18n[_vm.locale]['already_exists']))])]), _vm._v(" "), (_vm.subjectsCanBeDeleted.length > 0) ? _c('h4', {
    staticClass: "marg-1-top"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['do_you_want_to_delete']) + "?")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "klassesWithSubjects"
  }, _vm._l((_vm.subjectsCanBeDeletedWithVProps), function(subject) {
    return _c('tr', {
      key: subject.id
    }, [_c('td', [_vm._v(_vm._s(subject.v_calendar_name) + " ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "d-subject",
      style: ({
        'background': subject.color
      })
    }, [_vm._v(_vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")")])])])
  }), 0), _vm._v(" "), (_vm.subjectsCannotDelete.length > 0) ? _c('p', {
    staticClass: "bold italic marg-1-top text-danger"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['subject_cannot_be_deleted']))]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "klassesWithSubjects"
  }, _vm._l((_vm.subjectsCannotDeleteWithVProps), function(subject) {
    return _c('tr', {
      key: subject.id
    }, [_c('td', [_vm._v(_vm._s(_vm.subjectsCannotDelete.v_calendar_name) + " ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "d-subject d-subject--cannot-delete",
      style: ({
        'background': subject.color
      })
    }, [_vm._v("\n              " + _vm._s(subject.name) + " (" + _vm._s(subject.hours) + ")\n            ")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons pad-1"
  }, [_c('button', {
    staticClass: "bttn marg-1-right",
    on: {
      "click": _vm.keepExistingSubjects
    }
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale]['create_new_anyway']))]), _vm._v(" "), (_vm.subjectsCanBeDeleted.length > 0) ? _c('button', {
    staticClass: "bttn submit-button",
    on: {
      "click": _vm.deleteExistingSubjects
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  }), _vm._v(" " + _vm._s(_vm.i18n[_vm.locale]['delete']) + "\n      ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a7f3a51e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/SubjectFormDeleteSubjects.vue
// module id = 1717
// module chunks = 1